<template lang="pug">
  .flow-builder-action-show-products-template
    template-tools(v-if="!disabled", @delete="$emit('delete')")
    .template-platforms-container.badges.mb-3(v-if="disabled")
      b-badge(v-for="(platform) in selectedPlatformsObjects.slice(0, sliceEnd)", :key="platform.platform_id", :style="{'background-color': platformColor(platform.name, 0.7)}") {{ platform.title }}
      b-badge(v-if="selectedPlatformsObjects.slice(sliceEnd).length", variant="soft-secondary") {{ selectedPlatformsObjects.slice(sliceEnd).length }} más
    .template-platforms-container.overflow-x.no-wrap.mb-3(v-else)
      b-form-group
        label.text-help.text-sm Plataformas donde se usará este template:
        k-select.disabled-white.flush(placeholder="- Agregar plataformas -", :options="parsedPlatforms", :disabled="disabled", :value="selected_platforms", @input="updatePlatforms", multiple, :limit="3", :searchable="false")
    b-card.mb-0.no-shadow.w-100.bg-light-white
      .bg-white.mb-3
        p.mb-0 Punto de control
        p.text-secondary.text-sm  Crea o actualiza un punto de control. Este punto de control marca como alcanzada una etapa de un objetivo
        //result-description.mb-3(variable-name="web", variable-type="object")
        fieldset.mb-3(:disabled="disabled")
          b-form-group(label="Objetivo:", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'objective_id'")
            b-form-select(:value="template_attribute.value || null", @change="selectObjective(template_attribute, $event)")
              option(:value="null", disabled) --Selecciona objetivo--
              option(v-for="objective in objectives", :key="objective._id", :value="objective._id") {{objective.name}}
          b-form-group(label="Etapa:", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'step'")
            b-form-select(:value="template_attribute.value || null", @change="updateTemplateAttribute(template_attribute, $event)", :disabled="!steps.length")
              option(:value="null", disabled) --Selecciona etapa--
              option(v-for="step in steps", :key="step.index", :value="step.index") {{step.title}}
          b-form-group(label="Rama:", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'branch'")
            b-form-select(:value="template_attribute.value || null", @change="updateTemplateAttribute(template_attribute, $event)")
              option(:value="''", disabled) --Selecciona rama--
              option(v-for="branch in branches", :key="branch", :value="branch") {{branch || 'Principal'}}
</template>

<script>
import templateCommon from '../../helpers/template-common'
import Connector from './connectors/Connector.vue'
import TemplateTools from './common/Tools.vue'
import ResultDescription from './helpers/ResultDescription'
import { createNamespacedHelpers, mapActions } from 'vuex'

const objectivesController = createNamespacedHelpers('objective')

export default {
  mixins: [templateCommon],
  data () {
    return {
      loading: false
    }
  },
  computed: {
    ...objectivesController.mapState({
      objectives: state => state.objectives
    }),
    objectiveId () {
      const objective_attr = this.getAttribute('objective_id')
      if (objective_attr && objective_attr.value) {
        return objective_attr.value
      }
      return null
    },
    steps () {
      if(this.objectiveId) {
        const objective = this.objectives.find(el => el._id === this.objectiveId)
        if(objective) {
          return objective.steps
        }
      }
      return []
    },
    branches () {
      if(this.objectiveId) {
        const objective = this.objectives.find(el => el._id === this.objectiveId)
        if(objective) {
          const { branches = [] } = objective
          return [null, ...branches]
        }
      }
      return [null]
    }
  },
  methods: {
    ...mapActions(['objective/all', 'objective/get']),
    getObjectives () {
      let self = this

      this['objective/all']({
        account_id: self.$route.params.account_id,
        params: {
          enabled: true
        },
        callback: res => {
          self.busy = false
          if (res.error) {
            self.$message.error(res.error)
          }
        }
      })
    },
    selectObjective (template, value) {
      template.value = value
      this.updateAttribute(this.block_id, this.template_id, template)
      for (const name of ['step', 'branch']) {
        const attrTemplate = this.getAttribute(name)

        if (attrTemplate) return this.updateTemplateAttribute(attrTemplate, null)
      }
    },
    updateTemplateAttribute (template_attribute, value) {
      const attribute = JSON.parse(JSON.stringify(template_attribute))
      attribute.value = value

      this.updateAttribute(this.block_id, this.template_id, attribute).then(() => {
        this.$message.success('Actualizado')
      })
    }
  },
  components: {
    'template-connector': Connector,
    TemplateTools,
    ResultDescription,
  },
  mounted () {
    this.$root.$on('bv::collapse::state', (collapseId) => {
      if (collapseId === `advance_search_collapse_${this.template_id}`) {
        setTimeout(() => {
          this.repaintBlock()
        }, 500)
      }
    })
    this.getObjectives()
  }
}
</script>

<style lang="scss" scoped>

</style>
